module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('lee-header'), _vm._v(" "), _c('main', [_c('div', {
    staticClass: "sidebar"
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "collapse": _vm.isCollapse,
      "theme": "dark"
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    },
    on: {
      "click": function($event) {
        _vm.changeIndex('1')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    slot: "title"
  }, [_vm._v("Home")])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/picture"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "2"
    },
    on: {
      "click": function($event) {
        _vm.changeIndex('2')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-photo"
  }), _vm._v(" "), _c('span', {
    slot: "title"
  }, [_vm._v("Pictures")])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/chart"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "3"
    },
    on: {
      "click": function($event) {
        _vm.changeIndex('3')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" "), _c('span', {
    slot: "title"
  }, [_vm._v("Chart")])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/table"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "4"
    },
    on: {
      "click": function($event) {
        _vm.changeIndex('4')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" "), _c('span', {
    slot: "title"
  }, [_vm._v("Table")])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/markdown"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "5"
    },
    on: {
      "click": function($event) {
        _vm.changeIndex('5')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-maxcdn"
  }), _vm._v(" "), _c('span', {
    slot: "title"
  }, [_vm._v("Markdown")])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/cropper"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "6"
    },
    on: {
      "click": function($event) {
        _vm.changeIndex('6')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-crop"
  }), _vm._v(" "), _c('span', {
    slot: "title"
  }, [_vm._v("Cropper")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('router-view'), _vm._v(" "), _vm._m(0)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "content-footer"
  }, [_vm._v("Author : "), _c('a', {
    staticClass: "primary-text",
    attrs: {
      "href": "https://github.com/Leecason",
      "target": "_blank"
    }
  }, [_vm._v("Leecason")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-641c1b67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 602
// module chunks = 1